import useConfig from "../../../../../actions/Tenants/config/configHook";
import { Loading } from "../../../../Helper/Loading";
import { useQcEntities } from "../../QcEntityContext";
import { DeprecatedManualForm } from "../DeprecatedManualCheckForm";
import { FruitMetaForm, FruitMetaFormProps } from "./FruitMetaForm";

import { useRouteLayerQuery, useRouteCheckQuery } from "../../../../../hooks/useCurrentEntities";

export const ManualForm = ({ avocado, grid = false, type = "primary" }: Pick<FruitMetaFormProps, "avocado" | "grid"> & { type?: "primary" | "secondary" }) => {
    const config = useConfig();

    const { check, layer } = useQcEntities();
    const checkLoading = useRouteCheckQuery().isLoading;
    const layerLoading = useRouteLayerQuery().isLoading;
    const fields = type === "primary"
        ? config.get_fruit_form(layer, check, avocado)
        : config.get_secondary_fruit_form(layer, check, avocado);

    if (checkLoading || layerLoading) return <Loading />;

    // * fall back to form defined with legacy fields (only path as option)
    if (!fields || fields.length === 0) {
        return <DeprecatedManualForm avocado={avocado} />;
    }

    if (!(avocado.avocado_id > 0)) {
        return null;
    }

    return <FruitMetaForm avocado={avocado} fields={fields} grid={grid} />;
};
